import { useContext, useEffect, useRef } from 'react';

import { EventContext } from 'contexts/EventContext';
import { FeedbackContext } from 'contexts/FeedbackContext';
import useIntersection from 'hooks/useIntersection';
import PageSectionContainer from 'components/page/PageSectionContainer';
import ContactCard from 'components/service-center/ContactCard';

const ContactSection = () => {
  const ref = useRef<any>();
  const isVisible = useIntersection(ref);
  const feedback = useContext(FeedbackContext);
  const event = useContext(EventContext);

  useEffect(() => {
    if (isVisible && !feedback?.show) {
      event?.emitCustomEvent('end-of-page', {
        action: 'prompt-feedback',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <PageSectionContainer ref={ref} className="section__contact">
      <ContactCard />
    </PageSectionContainer>
  );
};

export default ContactSection;
